<template>
  <div class="right-search-chart">
    <div
      class="table-with-search settings-tab"
      :class="{ 'no-content': noContent }"
      style="min-height: 50px;"
    >
      <p v-if="noContent">{{ $t('dashboard.news.noContent') }}</p>
      <div v-if="haveContentNews" class="switchs-graph" id="graph1">
        <div class="tableCover Custom_Scrollbar">
          <table id="searchTable">
            <tbody>
              <tr v-for="n in newsSorted" :key="n.PostId">
                <td>
                  <a
                    :href="n.url"
                    @click.prevent="$emit('newsclick', { id: n.id, db: n.db })"
                    target="_blank"
                    class="custom-text"
                    rel="noreferrer"
                  >
                    <template v-if="!n.title || String(n.title).length == 0">
                      {{ n.url | shortText(100) }}
                    </template>
                    <template v-else>
                      {{ n.title | stripTags | shortText(100) }}
                    </template>
                  </a>
                  <div class="bottom-text">
                    <span
                      >{{
                        (n.group.length > 0 ? n.group : '')
                          | shortText(n.host.length > 0 ? 15 : 30)
                      }}
                      {{ n.host.length > 0 && n.group.length > 0 ? '|' : '' }}
                      {{
                        (n.host.length > 0 ? ` ${n.host} ` : '')
                          | shortText(n.group.length > 0 ? 15 : 30)
                      }}
                      | {{ n.date && n.date.fromNow(true) }}</span
                    >
                    <span
                      class="float-right"
                      :class="{
                        'text-red': n.sentiment < 0,
                        'text-primary': n.sentiment > 0,
                      }"
                      >{{ getSentString(n.sentiment) }}</span
                    >
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        class="settings-tab-overlay multi-collapse collapse"
        :class="{ show: $store.state.layout.settingsOpened }"
        id="setting-overlay"
        style=""
      >
        <!-- ANIMATED CHECKBOXES -->
        <div class="checkbox-group form-group">
          <div class="checkbox-animated delay1">
            <input id="checkbox_animated_4" type="checkbox" />
            <label for="checkbox_animated_4">
              <span class="check"></span>
              <span class="box"></span>
              Русский
            </label>
          </div>
          <div class="checkbox-animated delay2">
            <input id="checkbox_animated_5" type="checkbox" />
            <label for="checkbox_animated_5">
              <span class="check"></span>
              <span class="box"></span>
              Английский
            </label>
          </div>
          <div class="checkbox-animated delay3">
            <input id="checkbox_animated_6" type="checkbox" />
            <label for="checkbox_animated_6">
              <span class="check"></span>
              <span class="box"></span>
              Китайский
            </label>
          </div>
          <div class="checkbox-animated delay4">
            <input id="checkbox_animated_7" type="checkbox" />
            <label for="checkbox_animated_7">
              <span class="check"></span>
              <span class="box"></span>
              Немецкий
            </label>
          </div>
          <div class="checkbox-animated delay5">
            <input id="checkbox_animated_8" type="checkbox" />
            <label for="checkbox_animated_8">
              <span class="check"></span>
              <span class="box"></span>
              Французский
            </label>
          </div>
          <div class="checkbox-animated delay6">
            <input id="checkbox_animated_9" type="checkbox" />
            <label for="checkbox_animated_9">
              <span class="check"></span>
              <span class="box"></span>
              Кирилица
            </label>
          </div>
          <div class="checkbox-animated delay7">
            <input id="checkbox_animated_10" type="checkbox" />
            <label for="checkbox_animated_10">
              <span class="check"></span>
              <span class="box"></span>
              Латиница
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import filters from '@/utils/filters'

export default {
  computed: {
    haveContentNews() {
      return this.news && this.news.length !== 0
    },
    noContent() {
      return !this.haveContentNews
    },
    newsSorted() {
      return [...this.news].sort(
        (a, b) => (b.date && b.date.valueOf()) - (a.date && a.date.valueOf())
      )
    },
  },
  methods: {
    getSentString(v) {
      return v > 0
        ? this.$t('dashboard.news.positive')
        : v < 0
        ? this.$t('dashboard.news.negative')
        : this.$t('dashboard.news.neutral')
    },
  },
  props: {
    title: String,
    news: Array,
    avg: Number,
  },
  filters: {
    shortText: filters.shortText,
    stripTags: filters.stripTags,
  },
}
</script>

<style lang="scss">
.table-with-search {
  font-size: 0.75rem;
  font-weight: 700;
  height: 100%;

  .tableCover {
    overflow-y: scroll;
    padding-right: 20px;
    height: 310px;

    #searchTable,
    #searchTable2 {
      width: 100%;
    }

    @media (max-width: 1240px) {
      max-height: 305px;
      min-height: 180px;
    }
  }

  td {
    border-bottom: 1px solid #c2c2d6;
    padding: 4px 0;
    word-break: break-all;

    .custom-text {
      font-family: $primary-font;
      font-style: normal;
      font-weight: normal;
      font-size: 0.75rem;
      line-height: 1rem;
      color: #000000;
      @include transition();

      &:hover {
        color: $primary-color2;
      }
    }

    span {
      font-style: normal;
      font-weight: normal;
      font-size: 0.75rem;
      line-height: 1rem;
      color: #8a8a8a;
      margin: 4px 0px;
      display: inline-block;
    }
  }
}
</style>
